import React from 'react';
import Cart from './cart.jsx';
function Header({ configuration }) {
  return (
    <div className="dbg_header bg-color--thule-light-grey d-flex justify-content-between">
      <div className="d-flex align-items-center">
        <div className="logotype-container">
          <i className="logotype" />
        </div>

        <a href={configuration.ReturnFromFitGuideURL}>
          <img src={configuration.Logo} alt={configuration.LogoAlt} /> <div className="sr-only">Go to retailer</div>
        </a>
      </div>
      <div className="d-flex align-items-center">
        <Cart configuration={configuration} />
      </div>
    </div>
  );
}

export default Header;
